module.exports = __webpack_public_path__ + "img/117.86ec1fbd.jpg";